import { FC } from "react";
import { DropdownOptionsMaster, GenericAppThemeProperty } from "../Types";
import OptionsPropertyCard from "../Cards/OptionsPropertyCard";
import { Grid } from "@material-ui/core";

type OptionsPropertiesListProps = {
  propertiesList: GenericAppThemeProperty[];
  type: string;
};

const getOptionsForProperty = (
  type: string,
  property: GenericAppThemeProperty,
  optionsList: DropdownOptionsMaster[]
): { label: string; value: string }[] => {
  if (type === "behavior") {
    return [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ];
  } else {
    const filteredOptions = optionsList
      ?.filter(opt => opt.themePropertyMasterKey === property.themePropertyMasterKey)
      ?.sort((a, b) => a.sortOrder - b.sortOrder)
      ?.map(opt => ({
        label: opt.label,
        value: opt.value
      }));

    if (!filteredOptions || filteredOptions.length === 0) {
      // fallback option
      return property.value
        ? [{ label: property.value, value: property.value }]
        : [];
    }

    return filteredOptions;
  }
};

const OptionsPropertiesList: FC<OptionsPropertiesListProps> = ({ propertiesList, type }) => {
  const sortedProps = [...propertiesList].sort((a, b) =>
    a.propertyLabel.toLowerCase().localeCompare(b.propertyLabel.toLowerCase())
  );

  return (
    <>
      <Grid container spacing={2} sx={{ padding: '1%' }}>
        {sortedProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={property.themePropertyKey}>
            <OptionsPropertyCard property={property} options={getOptionsForProperty(type, property, [])} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default OptionsPropertiesList;